<template>
  <div class="about">
    <div class="container">
      <div class="row mt-3">
        <div class="col-lg-6">
          <h2 class="mb-3">About Dogo di Cattaro</h2>
          <hr
            class="line text-center"
            style="margin-bottom:20px; margin-top:-10px; text-align:left;"
          />
          <p style="text-align:left;">
            Dogo di Cattaro is a kennel for the Dogo Argentino breed, founded in
            2015 and has been operating within the Top Dogo Montenegro Team
            since 2020. The aim of the kennel "Dogo di Cattaro" is to maintain
            the tradition of the race Dogo Argentino and to try to improve the
            race, in accordance with the guidelines left by the creator of the
            race, Mr Antonio Nores Martinez. In order to achieve our goal, we
            had to provide strong basis and the offspring of the best
            representatives of the race, which proved to be extraordinary
            exhibits, and, at the same time, the best working dogs within the
            race. Dogo di Cattaro is based on the offspring of the best
            representatives of kennels De la Cocha, Del Litoral, De el Tumi,Di
            casa Nardini,Alfa Fiera,De la Paco Cassa. In a very short period of
            time, the dogs from our breeding managed to become European and
            World Champions, so we can proudly say that Dogo di Cattaro is home
            to World and European Champions.
          </p>
        </div>
        <div class="col-lg-6 mt-3">
          <img src="pas1.png" width="100%" alt="" />
        </div>
      </div>
    </div>
    <div class="container-fluid"></div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
img {
  margin: auto;
  display: block;
}
p {
  color: rgb(182, 178, 175);
}
h2 {
  color: rgb(182, 178, 175);
}
hr.line {
  border: 2px solid #ffd700;
  width: 100px;
  margin: 0px auto;
}
.container-fluid {
  border-bottom: 2px solid rgb(182, 178, 175);
}
</style>
